<div class="contact_us_page header_top mb-3">
  <div class="contact_banner">
    <div class="container">
      <h3>Contact Us</h3>
    </div>
  </div>
  <div class="contact_card mt-4">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-sm-12">
          <div class="card_content">
            <img loading="lazy" src="../../../assets/images/contactus/call.webp" alt="">
            <h2>Emergency</h2>
            <a href="tel:8606443030">86064 43030</a>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12">
          <div class="card_content">
            <img loading="lazy" src="../../../assets/images/contactus/work_hrs.webp" alt="">
            <h2>Work Hour</h2>
            <p>08:30 AM - 05:00 PM Everyday</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12">
          <div class="card_content">
            <img loading="lazy" src="../../../assets/images/contactus/location.webp" alt="">
            <h2>Location</h2>
            <a href="https://maps.app.goo.gl/bji3g1gtrJMK8rcq7" target="_blank">Kannur, Kerala 670001</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="contact_form mt-4">
    <div class="container">

      <div class="row mt-4 form_map">
        <div class="col-lg-6 co-md-6 col-sm-12">
          <h6>Book Appointment</h6>
          <p>Book an appointment by filling the form below. Our representative will get back to you
            at the earliest.</p>



          <form #patientForm="ngForm" (ngSubmit)="onSubmit(patientForm)">
            <div class="row">
              <!--  Full Name -->
              <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label> Full Name</label>
                  <input type="text" maxlength="25" name="patientName" ngModel required placeholder="Full Name">
                  <div *ngIf="patientForm.submitted && patientForm.controls['patientName']?.invalid"
                    class="text-danger">
                    Full Name is required.
                  </div>
                </div>
              </div>

              <!--  Email -->
              <div class="col-lg-6 col-md-12">
                <!-- <div class="form_input">
                                    <label> Email</label>
                                    <input type="email" name="patientEmail"  maxlength="25" ngModel required placeholder=" Email">
                                    <div *ngIf="patientForm.submitted && patientForm.controls['patientEmail']?.invalid" class="text-danger">
                                       Email is required.
                                    </div>
                                  </div> -->


                <div class="form_input">
                  <label> Email</label>
                  <input type="email" name="patientEmail" ngModel required maxlength="150"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" placeholder=" Email">

                  <!-- Error for required -->
                  <div *ngIf="patientForm.submitted && patientForm.controls['patientEmail']?.errors?.['required']"
                    class="text-danger">
                    Email is required.
                  </div>

                  <!-- Error for invalid email pattern -->
                  <div *ngIf="patientForm.submitted && patientForm.controls['patientEmail']?.errors?.['pattern']"
                    class="text-danger">
                    Enter a valid email address.
                  </div>
                </div>
              </div>

              <!--  Mobile Number -->
              <!-- <div class="col-lg-6 col-md-12">
                                  <div class="form_input">
                                    <label> Mobile Number</label>
                                    <input type="text" name="patientMobile" ngModel required placeholder=" Mobile Number">
                                    <div *ngIf="patientForm.submitted && patientForm.controls['patientMobile']?.invalid" class="text-danger">
                                       Mobile Number is required.
                                    </div>
                                  </div>
                                </div> -->

              <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label> Mobile Number</label>
                  <input type="text" name="patientMobile" ngModel required pattern="^[0-9]{10}$" maxlength="10"
                    placeholder=" Mobile Number" onkeypress="return event.charCode >= 48 && event.charCode <= 57">

                  <!-- Error for required -->
                  <div *ngIf="patientForm.submitted && patientForm.controls['patientMobile']?.errors?.['required']"
                    class="text-danger">
                    Mobile Number is required.
                  </div>

                  <!-- Error for invalid number -->
                  <div *ngIf="patientForm.submitted && patientForm.controls['patientMobile']?.errors?.['pattern']"
                    class="text-danger">
                    Enter a valid 10-digit mobile number.
                  </div>
                </div>
              </div>

              <!-- Treatment Name -->
              <!-- <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <select name="" id="" maxlength="25" name="treatmentName" ngModel required
                    placeholder="Treatment Name">
                    <option value="">Select Treatment</option>
                    <option value="">Ovulation Induction Treatment</option>
                    <option value="">Intrauterine Insemination (IUI)</option>
                    <option value="">In Vitro Fertilization (IVF) </option>
                    <option value="">ICSI & PICSI Treatment</option>
                    <option value="">Preimplantation Genetic Testing</option>
                    <option value="">Recurrent Implantation Failure Treatment </option>
                    <option value="">Recurrent Pregnancy Loss (RPL) Treatment</option>
                  </select>
                  <div *ngIf="patientForm.submitted && patientForm.controls['treatmentName']?.invalid"
                    class="text-danger">
                    Treatment Name is required.
                  </div>
                </div>
              </div> -->

              <!-- <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label>Treatment Name</label>
                  <select name="treatmentName" ngModel [(ngModel)]="selectedTreatment" required>
                    <option value="">Select Treatment</option>
                    <option value="Ovulation Induction Treatment">Ovulation Induction Treatment</option>
                    <option value="Intrauterine Insemination (IUI)">Intrauterine Insemination (IUI)</option>
                    <option value="In Vitro Fertilization (IVF)">In Vitro Fertilization (IVF)</option>
                    <option value="ICSI & PICSI Treatment">ICSI & PICSI Treatment</option>
                    <option value="Preimplantation Genetic Testing">Preimplantation Genetic Testing</option>
                    <option value="Recurrent Implantation Failure Treatment">Recurrent Implantation Failure Treatment
                    </option>
                    <option value="Recurrent Pregnancy Loss (RPL) Treatment">Recurrent Pregnancy Loss (RPL) Treatment
                    </option>
                  </select>
                  <div *ngIf="patientForm.submitted && patientForm.controls['treatmentName']?.invalid"
                    class="text-danger">
                    Treatment Name is required.
                  </div>
                </div>
              </div> -->


              <!-- Date -->
              <!-- <div class="col-lg-6 col-md-12">
                                  <div class="form_input">
                                    <label>Date</label>
                                    <input type="text" name="date" ngModel required placeholder="Date">
                                    <div *ngIf="patientForm.submitted && patientForm.controls['date']?.invalid" class="text-danger">
                                      Date is required.
                                    </div>
                                  </div>
                                </div> -->

              <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label>Appointment Date</label>
                  <input type="date" name="date" ngModel class="custom-date" required [min]="todayDate"
                    placeholder="Date">

                  <!-- Error for required -->
                  <div *ngIf="patientForm.submitted && patientForm.controls['date']?.errors?.['required']"
                    class="text-danger">
                    Date is required.
                  </div>
                </div>
              </div>

              <!-- City -->
              <!-- <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label>City</label>
                  <input type="text" name="city" ngModel  placeholder="City">
                  <div *ngIf="patientForm.submitted && patientForm.controls['city']?.invalid" class="text-danger">
                    City is required.
                  </div>
                </div>
              </div> -->

              <!-- State -->
              <!-- <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label>State</label>
                  <input type="text" name="state" ngModel  placeholder="State">
                  <div *ngIf="patientForm.submitted && patientForm.controls['state']?.invalid" class="text-danger">
                    State is required.
                  </div>
                </div>
              </div> -->

              <!-- Country -->
              <!-- <div class="col-lg-6 col-md-12">
                <div class="form_input">
                  <label>Country</label>
                  <input type="text" name="country" ngModel  placeholder="Country">
                  <div *ngIf="patientForm.submitted && patientForm.controls['country']?.invalid" class="text-danger">
                    Country is required.
                  </div>
                </div>
              </div> -->

              <!-- Message (Optional) -->
              <div class="col-12">
                <div class="form_input">
                  <label>Message</label>
                  <textarea name="message" ngModel placeholder="Write to us..."></textarea>
                </div>
              </div>

              <!-- Terms and Conditions -->
              <!-- <div class="col-12">
                <div class="input_accept">
                  <input type="checkbox" [(ngModel)]="acceptTerms" name="acceptTerms">
                  I agree to the
                  <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>.
                </div>
              </div> -->

              <!-- Submit Button -->
              <div class="col-12 text-center mt-3">
                <button type="submit">Submit</button>
              </div>

            </div>
          </form>


        </div>
        <div class="col-lg-6 co-md-6 col-sm-12">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d62471.87263333651!2d75.29187022167969!3d11.870787100000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba43d4a8689a10d%3A0x99ec40cc63f3f3b9!2sNCare%20IVF%20Centre!5e0!3m2!1sen!2sin!4v1747507249311!5m2!1sen!2sin"
            width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  </div>

</div>